import { render, staticRenderFns } from "./MandatorySurvey.vue?vue&type=template&id=d1f27852&"
import script from "./MandatorySurvey.vue?vue&type=script&lang=js&"
export * from "./MandatorySurvey.vue?vue&type=script&lang=js&"
import style0 from "./MandatorySurvey.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MandatorySurvey.vue"
export default component.exports